import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const verses = [
  "بِسْمِ ٱللّٰهِ ٱلرَّحْمٰنِ ٱلرَّحِيمِ",
  "وَمَا مِن دَابَّةٍ فِي الْأَرْضِ إِلَّا عَلَى اللَّهِ رِزْقُهَا",
  "وَيَرْزُقْهُ مِنْ حَيْثُ لَا يَحْتَسِبُ",
  "إِنَّ اللَّهَ هُوَ الرَّزَّاقُ ذُو الْقُوَّةِ الْمَتِينُ",
  "اللَّهُمَّ إِنِّي أَسْأَلُكَ عِلْماً نَافِعاً، وَرِزْقاً طَيِّباً، وَعَمَلاً مُتَقَبَّلاً",
  "اللَّهُمَّ ٱرْزُقْنِي مِنْ فَضْلِكَ ٱلْوَاسِعِ"
]

const QuranicVerseBanner = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % verses.length)
    }, 10000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="bg-gradient-to-r from-fresh-green/10 to-chicken-gold/10 py-4 text-center">
      <AnimatePresence mode="wait">
        <motion.p
          key={currentIndex}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          transition={{ duration: 0.5 }}
          className="text-charcoal font-medium text-lg md:text-xl"
        >
          {verses[currentIndex]}
        </motion.p>
      </AnimatePresence>
    </div>
  )
}

export default QuranicVerseBanner
